<template lang="pug">
  DataTablePage(
    pid="parentId"
    cid="id"
    mainColumn="name"
    longColumn="name"
    resource="meterPayload/area"
    title="区域管理"
    label="区域"
    labelName="name"
    :formLabelWidth="4"
    :isTree="true"
    :operation="operation"
    :operationWidth=158
    :toolbar="toolbar"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :createFormValues="createFormValues"
    :columns="columns")
</template>
<script>
import DataTablePage from '@/containers/DataTablePage'
import { operationCreate, operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
// import columns from './columns.js'

export default {
  name: 'SystemMenu',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    const hasUpdate = checkActions('/system/menu/update')
    const hasCreate = checkActions('/system/menu/create')
    const hasDelete = checkActions('/system/menu/delete')
    return {
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/account/create')
        }
      }],
      operation: [{
        ...operationCreate,
        isShow () {
          return hasCreate
        }
      }, {
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }],
      tableInitList: ['name'],
      tableFullList: ['name'],
      filterInitList: ['name'],
      filterFullList: ['name'],
      createList: ['name'],
      updateList: ['name'],
      orderByInit: [{
        name: 'sort',
        sort: 'asc'
      }],
      createFormValues: {
        parentId: '',
        name: '',
        menuTypeId: '',
        url: '',
        icon: '',
        enabled: 1,
        sort: 0,
        remark: ''
      },
      columns: {
        parentId: {
          label: '上级区域id',
          type: 'select',
          form: {
            type: 'select',
            rules: [{
              type: 'required',
              dataType: 'select',
              message: '请选择上级区域'
            }]
          }
        },
        path: {
          label: '区域上下级路径',
          width: 180,
          form: {
            type: 'input'
          },
          filter: {
            type: 'input',
            like: true
          }
        },
        name: {
          label: '区域名称',
          form: {
            type: 'input',
            // width: 120,
            rules: [{
              type: 'required',
              dataType: 'input',
              message: '请输入区域名称'
            }]
          },
          filter: {
            type: 'input',
            like: true
          }
        },
        level: {
          label: '区域等级',
          style: {
            'text-align': 'center'
          },
          form: {
            type: 'Number'
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Area.vue?584b1957